import { Chip } from '@global-engineering-shared/gweb-material-global';
import {
  GlobalCard,
  GlobalCardBody,
  GlobalCardHeader,
  GlobalCardHeaderTitle,
} from '@global-engineering-shared/gweb-material-lab';
import { Typography } from '@global-engineering-shared/gweb-material-ui';
import React, { useEffect, useState } from 'react';

import { useFilters } from 'context/FilterProvider/FilterProvider';
import { Filters } from 'context/FilterProvider/types/Filters';
import { defaultFilters } from 'context/FilterProvider/utils/defaultFilters';
import { stateWriter } from 'features/Status/utils/statusWriter';

import useStyles from './FilterChipsContainer.styles';

type FilterChipProps = {
  name: string;
  filterType: string;
};

const FilterChipsContainer = () => {
  const classes = useStyles();
  const [filterChips, setFilterChips] = useState<FilterChipProps[]>([]);

  const { filters, setFilters } = useFilters();

  useEffect(() => {
    const filterChipsBuilder: any = [];

    Object.keys(filters).forEach((filterType) => {
      const currentFilters = filters[filterType as keyof Filters];

      if (filterType === 'frameId') {
        if (currentFilters.length > 0) {
          filterChipsBuilder.push({ name: currentFilters[0], filterType: filterType });
        }
      } else {
        currentFilters.forEach((f) => {
          filterChipsBuilder.push({ name: f, filterType: filterType });
        });
      }
    });

    setFilterChips(filterChipsBuilder);
  }, [filters]);

  const removeSingleFilter = (filterValue: string, filterType: string) => () => {
    const updatedFilters = filters;

    if (filterType === 'frameId') {
      updatedFilters[filterType as keyof Filters] = [];
    }
    const filterTypeToUpdate = updatedFilters[filterType as keyof Filters];

    filterTypeToUpdate.splice(filterTypeToUpdate.indexOf(filterValue), 1);

    setFilters(updatedFilters);
  };

  const getLabel = (filter: FilterChipProps) => {
    if (filter.filterType === 'status') {
      return stateWriter(filter.name);
    } else if (filter.filterType === 'frameId') {
      return `${filters.frameId?.length} Frame IDs`;
    } else {
      return filter.name;
    }
  };

  return (
    <GlobalCard className={classes.filterCard}>
      <GlobalCardHeader>
        <GlobalCardHeaderTitle
          TitleComponent={() => <Typography className={classes.labelTitle}>FILTERS</Typography>}
        />
      </GlobalCardHeader>
      <GlobalCardBody>
        {filterChips.map((filter) => (
          <Chip
            className={classes.filterChip}
            label={getLabel(filter)}
            key={filter.name}
            onDelete={removeSingleFilter(filter.name, filter.filterType)}
          />
        ))}
        <span className={classes.clearFilters} onClick={() => setFilters(defaultFilters)}>
          Clear All
        </span>
      </GlobalCardBody>
    </GlobalCard>
  );
};

export default FilterChipsContainer;
